import { Component } from '@angular/core';

@Component({
    selector: 'eca-error-logged-out-landing',
    templateUrl: './error-logged-out-landing.component.html',
    styleUrls: ['./error-logged-out-landing.component.css']
})
export class ErrorLoggedOutLandingComponent {

  constructor() { }

}
